import i18n from '@/plugins/i18n/index.js'

export default function transExperiences () {
  return [
    { experience: i18n.t('general.trips'), label: 'trips' },
    { experience: i18n.t('general.concerts'), label: 'concerts' }
  ]
}
